// extracted by mini-css-extract-plugin
module.exports = {"title":"PrivacyPolicy_title_3dh63","subTitle":"PrivacyPolicy_subTitle_3q0Hi"};